// extracted by mini-css-extract-plugin
export default {"grid":"loader_grid__HnNtg"};